import { DOMAIN } from 'src/constants';

import { getPostMediaUrl } from './thumbnailUtil';
import { removeAtLastIndex } from './urlUtil';

const noThumbnail = '@imagesno-thumbnail.jpg';

// export const getPostTags = (post) => {
//   if (!post?.tags?.length || post?.tags?.length === 0) return null;

//   if (!post?.["_embedded"]?.["wp:term"]?.[1]?.length) return null;

//   const tags = post?.["_embedded"]?.["wp:term"][1].map(item => item.name);

//   return tags;
// };

export const getPostAuthorEmail = (post) => {
  if (!post._embedded?.author || post?._embedded?.author?.length === 0) {
    return;
  }

  if (!post._embedded?.author[0]?.acf?.email) {
    return;
  }

  return post._embedded['author'][0].acf.email;
};

export const getPostThumbnailUrl = (post) => {
  const defaultImg = noThumbnail;
  const { featured_media: featuredMedia } = post;
  if (featuredMedia) {
    const { localFile } = featuredMedia;
    if (localFile) {
      const { publicURL } = localFile;
      if (decodeURIComponent(publicURL)) {
        return getImageUrlBySize(publicURL);
      }
      if (localFile.url) {
        return localFile.url;
      }
      return defaultImg;
    }

    const sourceUrl = featuredMedia['source_url'];
    if (sourceUrl) {
      return sourceUrl;
    }
    return defaultImg;
  }
  const { acf } = post;
  if (acf) {
    const thumbnailOld = acf['thumbnail_old'];
    if (!thumbnailOld) {
      return defaultImg;
    }
    if (thumbnailOld.startsWith('/')) {
      return DOMAIN + thumbnailOld;
    }
    return DOMAIN + '/' + thumbnailOld;
  }
  return defaultImg;
};

export const getImageUrlBySize = (imageUrl, size) => {
  if (!size || size === '' || imageUrl.startsWith('data:image')) {
    return imageUrl;
  }
  const extensionIndex = imageUrl.lastIndexOf('.');
  const extension = imageUrl.substring(extensionIndex);
  let imageUrlWithoutExtension = imageUrl.substring(0, extensionIndex);

  if (imageUrlWithoutExtension.endsWith('-scaled')) {
    imageUrlWithoutExtension = imageUrlWithoutExtension.substring(
      0,
      imageUrlWithoutExtension.lastIndexOf('-scaled')
    );
  }

  return `${imageUrlWithoutExtension}-${size}${extension}`;
};

/****
 *
 * CATEGORY
 *
 */

const group_1 = [
  'Forex',
  'Coin',
  'Chứng khoán',
  'Đầu tư tài chính',
  'Hàng hóa',
  'Phân tích &amp; nhận định',
];

const group_2 = [
  'Kiến thức',
  'Tin tức',
  'Phân tích - nhận định thị trường',
  'Phân tích cơ bản',
  'Phân tích kỹ thuật',
  'Trade quỹ',
  'Các đồng coin trên thế giới',
  'Tài chính cá nhân',
  'Vàng và kim loại',
  'Năng lượng',
  'Nguyên liệu công nghiệp',
  'Nông sản',
];

const group_3 = [
  'Bitcoin - BTC',
  'Ethereum - ETH',
  'Litecoin - LTC',
  'Ripple - XRP',
  'Tether - USDT',
  'Banker_sharing',
  'Xu hướng defi',
  'Cách đào bitcoin',
  'Chuyên đề đặc biệt',
  'Khuyến mãi Forex Broker',
  'Review Broker',
  'Thông báo từ Broker',
  'Cơ hội đầu tư',
  'Stoploss và Take Profit',
  'Nhận định',
  'Review lệnh',
  'Back test',
  'Plan tuần',
  'Tín hiệu',
  'Kinh nghiệm thực chiến',
  'AUD',
  'EUR',
  'GBP',
  'USD',
  'WTI',
  'JPY',
  'CHF',
  'CAD',
  'Trade quỹ',
  'Tỷ giá đô la Úc',
  'Tỷ giá bảng Anh',
  'Tỷ giá Euro',
  'Tỷ giá USD',
  'Tỷ giá Yên Nhật',
  'Giá vàng hôm nay',
];

const group_4 = [];

export const getCategoryUrlFromListCategory = (categories) => {
  const rootCategory = categories.find((item) => group_1.includes(item.name));
  return categories.map((item) => {
    // create url Lĩnh vực (Nhóm 1)/"Product(Xauusd)  hoặc topic (nhóm 3)"
    if (!rootCategory) {
      return { ...item, url: `/${item.slug}` };
    }
    // group 3
    if (group_3.includes(item.name)) {
      return { ...item, url: `/${item.slug}` };
    }

    // group 1
    if (group_1.includes(item.name)) {
      return { ...item, url: `/${item.slug}` };
    }
    // if (!group_3.includes(item.name) && !group_4.includes(item.name)) {
    //   return item;
    // }
    return { ...item, url: `/${rootCategory.slug}/${item.slug}` };
  });
};

export const getCategoryBreadcrumbFromListCategory = (categories) => {
  categories = getCategoryUrlFromListCategory(categories);
  return categories
    .map((item) => {
      let position = null;
      if (group_1.includes(item.name)) {
        position = 1;
      }
      if (group_2.includes(item.name)) {
        position = 2;
      }
      if (group_3.includes(item.name)) {
        position = 3;
      }
      if (group_4.includes(item.name)) {
        position = 4;
      }
      return { ...item, position };
    })
    .filter((item) => item.position)
    .sort((a, b) => a.position - b.position);
};

export const removeCodesIframe = (content) => {
  const startString = '<!--codes_iframe';
  const endString = '/codes_iframe-->';
  const start = content.lastIndexOf(startString);
  const end = content.lastIndexOf(endString);
  if (start === -1 || end === -1) {
    return content;
  }
  const result =
    content.substring(0, start) + content.substring(end + endString.length, content.length);
  return result;
};

export const renderPostCategory = (cate) => {
  if (!cate || cate.includes('/')) return [];

  return JSON.parse(cate);
};

export const replaceDomain = (content) => {
  if (!content || content === '') return '';

  return content
    .replaceAll('href="http://vnrebates.net', `href="${DOMAIN}`)
    .replaceAll('href="https://vnrebates.net', `href="${DOMAIN}`)
    .replaceAll('href="https://vnrebates.org', `href="${DOMAIN}`)
    .replaceAll('href="https://vnrebates.info', `href="${DOMAIN}`);
};

export const filterOnlyNeededPostData = (post) => {
  return {
    acf: {
      attr_no_index: post?.acf?.attr_no_index || false,
      schema: post?.acf?.schema || '',
      coin_id: post?.acf?.coin_id || false,
    },
    author: post?.author || null,
    categories: post?.categories || [],
    content: {
      rendered: replaceDomain(post?.content?.rendered),
    },
    date: post?.date || null,
    excerpt: post?.excerpt || null,
    id: post?.id,
    last_modified: post?.last_modified || null,
    link: DOMAIN + '/' + post?.slug + '.html',
    rank_math_description: post?.rank_math_description || '',
    slug: post?.slug,
    title: post?.title,
    thumbnail: post?.thumbnail
  };
};
